import { routerStyxie } from '@/router/styxieBridge'

// Audit report configurations is client-side routed: every action boots the
// shared router shell. No styxie payload — the form takes the geogrid enums
// from GET /api/geogrids/page_meta and the edit record from
// GET /api/audit_report_configurations/:id in route `prepare`.
Styxie.Initializers.AuditReportConfigurations = routerStyxie({ actions: ['index', 'new', 'edit']})
